// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"1ab41dc6","409":"361b4b03","448":"1ab41dc6","509":"1ab41dc6","769":"a05b8706","909":"65bd4ed5"}[chunkId] + ".chunk.css";
};